import React from "react";
import PropTypes from "prop-types";
import { Card, Box, Typography } from "@mui/material";
import {
  SentimentDissatisfiedOutlined as EmptyIcon,
  FilterAltOffOutlined as ResetFilterIcon,
} from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { CommonButton } from "../../../../Components/ui";

const AllLotteriesEmptyState = ({ onReset, hasActiveFilters }) => {
  return (
    <Card
      sx={{
        p: { xs: 4, sm: 6 },
        textAlign: "center",
        borderRadius: borderRadiusPx.xl,
        backgroundColor: colors.dashboard.cardBg,
        border: `1px solid ${colors.dashboard.cardBorder}`,
        my: 3,
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          mx: "auto",
          mb: 2,
          borderRadius: "50%",
          bgcolor: colors.blue[50],
          color: colors.primary.main,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <EmptyIcon sx={{ fontSize: 32 }} />
      </Box>

      <Typography
        variant="h5"
        sx={{ fontWeight: 800, color: colors.slate[900], mb: 1 }}
      >
        No Lotteries Found
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: colors.slate[600],
          mb: 3,
          maxWidth: 440,
          mx: "auto",
          lineHeight: 1.5,
        }}
      >
        {hasActiveFilters
          ? "No on-chain lotteries match your current search or filter combination. Try adjusting or clearing your filters."
          : "There are currently no active lotteries deployed in this category. Check back shortly for newly scheduled draws!"}
      </Typography>

      {hasActiveFilters && (
        <CommonButton
          variant="primary"
          onClick={onReset}
          startIcon={<ResetFilterIcon />}
          sx={{ px: 3 }}
        >
          Reset All Filters
        </CommonButton>
      )}
    </Card>
  );
};

AllLotteriesEmptyState.propTypes = {
  onReset: PropTypes.func.isRequired,
  hasActiveFilters: PropTypes.bool,
};

export default AllLotteriesEmptyState;
